import type { PredictionStatus, Stage, StageUiState } from '../types'

export type StageConditionTagVariant =
  | 'success-filled'
  | 'success-outline'
  | 'warning-outline'
  | 'locked-outline'

export interface StageConditionTagConfig {
  label: string
  variant: StageConditionTagVariant
  icon: string | null
}

// Тексты и визуальные варианты Stage_condition_tag по ui_state
// (см. docs/pickem/docs/technical/03-api-basic.md → ui_state, prediction_status).
export const getStageConditionTag = (stage: Stage): StageConditionTagConfig => {
  if (
    stage.ui_state === 'awaiting_results' &&
    stage.lock_at &&
    stage.lock_at * 1000 < Date.now()
  ) {
    return {
      label: 'В процессе',
      variant: 'warning-outline',
      icon: 'play-filled'
    }
  }

  switch (stage.ui_state) {
    case 'awaiting_open':
      return {
        label: 'Ожидание начала',
        variant: 'success-filled',
        icon: 'play-filled'
      }
    case 'locked':
      return {
        label: 'Разблокировать',
        variant: 'locked-outline',
        icon: 'lock-circled'
      }
    case 'pickable':
      if (stage.prediction_status === 'full') {
        return {
          label: 'Команды выбраны',
          variant: 'success-outline',
          icon: 'check'
        }
      }
      if (stage.prediction_status === 'partial') {
        return {
          label: 'Есть пустые слоты',
          variant: 'warning-outline',
          icon: 'info-outline'
        }
      }
      return {
        label: 'Команды не выбраны',
        variant: 'warning-outline',
        icon: 'info-outline'
      }
    case 'awaiting_results':
      return {
        label: 'Ожидание результатов',
        variant: 'warning-outline',
        icon: 'play-filled'
      }
    case 'finished':
      return {
        label: 'Завершён',
        variant: 'success-outline',
        icon: 'check'
      }
  }
}

// countdown_to выставляется бэкендом для awaiting_open / pickable / awaiting_results.
export const timerTo = (
  stage: Pick<Stage, 'lock_at' | 'ui_state'>
): number | null => {
  // Не рисовать таймер, если оставшееся время до блокировки вышло либо нельзя принимать участие в этапе
  if (
    (stage.lock_at && stage.lock_at * 1000 < Date.now()) ||
    stage.ui_state !== 'pickable'
  ) {
    return null
  }

  return stage.lock_at
}
